import * as React from "react";
import styled from "styled-components";
import Theme from "../Theme";
import getUrl from "../functions/getUrl";

const defaultHeight = "200px";

export interface IMediaBreakpoints {
  minWidth: number;
  leftOffset: string;
  topOffset: string;
}

const HeaderImg = styled.div<{
  url: string;
  height?: string;
  mediaBreakpoints?: Array<IMediaBreakpoints>;
}>`
  background-image: url(${props => getUrl(props.url)});
  background-size: cover;
  width: 100%;
  height: ${props => (props.height ? props.height : defaultHeight)};
  color: ${Theme.colors.white};
  font-family: ${Theme.fonts.header};
  font-weight: bold !important;
  font-size: 2em;
  display: flex;
  position: relative;
  z-index: -2;
  flex-wrap: wrap;

  ${props =>
    props.mediaBreakpoints
      ? props.mediaBreakpoints.map(
          point =>
            `@media all and (min-width: ${point.minWidth}px) {
        & {
          background-position: ${point.leftOffset} ${point.topOffset};
        }
      }`,
        )
      : `@media all and (min-width: 0px) {
      & {
        background-position: 0 0;
      }
    }`}
`;

const ImgShader = styled.div<{ shadowOpacity?: number; height?: string }>`
  width: 100%;
  height: ${props => (props.height ? props.height : defaultHeight)};
  background-color: #000000;
  opacity: ${props => (props.shadowOpacity ? props.shadowOpacity : 0.2)};
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
`;

const ImgHeaderTitle = styled.div`
  text-align: left;
  z-index: 0;

  @media all and (min-width: 0px) {
    & {
      margin-left: 50px;
    }
  }
  @media all and (min-width: 1000px) {
    & {
      margin-left: 100px;
    }
  }
  @media all and (min-width: 1600px) {
    & {
      margin-left: 200px;
    }
  }
`;

export interface IImgHeaderProps {
  children: React.ReactNode;
  url: string;
  height?: string;
  shadowOpacity?: number;
  mediaBreakpoints?: Array<IMediaBreakpoints>;
}

const ImgHeader = (props: IImgHeaderProps) => (
  <HeaderImg {...props}>
    <ImgShader shadowOpacity={props.shadowOpacity} height={props.height} />
    <ImgHeaderTitle>{props.children}</ImgHeaderTitle>
  </HeaderImg>
);

export default ImgHeader;
